<template>
    <b-modal v-model="showModal" size="xl" @hidden="cancelar" @close="cancelar" button-size="md" hide-footer
        :title="prefix + title">
        <b-card bg-variant="light">
            <div class="d-flex align-items-center justify-content-center">
                <strong>{{ departamento.nome }}</strong>
            </div>
        </b-card>

        <b-card bg-variant="light">
            <b-table responsive class="mt-2" small :busy="this.busy" :items="this.almoxarifados"
                :fields="this.tableFields" :hover="true" show-empty>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>

                <template #empty>
                    <p>
                        Nenhum Registro encontrado
                    </p>
                </template>

                <template #head(select)="">
                    <b-form-checkbox v-model="selecionado" @change="selecionarTodos"  class="ml-3" :value="1" :unchecked-value="0" />
                </template>

                <template v-slot:cell(select)="row">
                    <b-form-checkbox @change="selecionarIndividual(row.item)" v-model="row.item.selecionado"
                        class="ml-3" :value="1" :unchecked-value="0" />
                </template>


            </b-table>
        </b-card>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource";
import { FormResourceMixin } from "@/core/mixins/resource";


export default {
    components: {
    },
    props: {
        departamento: {
            type: Object,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Configuração Almoxarifado",
        },
        currentSubgrupo: Object,
    },
    computed: {
        tableFields() {
            return [
                {
                    key: "modulo",
                    label: "Descrição",
                    thStyle: "font-size: 10px; font-weight: 400;",
                    tdStyle: "font-size: 10px",
                },
                {
                    key: "dataInicio",
                    label: "Data de Liberação",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "dataFim",
                    label: "Data de Término",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "select",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
            ]
        },
    },

    data() {
        return {
            selecionado: false,
            almoxarifados: [],
            showModal: true,
            form: {
                classe: {},
            },
        }
    },
    mixins: [ListResourceMixin, ConfirmMixin, FormResourceMixin],

    async beforeMount() {
        this.$service = new ResourceService('/api/departamento-modulo')
        this.load();
    },

    methods: {
        async selecionarTodos() {

            if (this.selecionado == 0) {
                let response = await this.$confirm(
                    "Após a operação, todos os acessos dos usuários desse módulo serão desativados. Tem certeza que deseja continuar?"
                );

                if (response == true) {
                    await this.$service.put(`liberar/${this.selecionado}/${this.departamento.id}/${0}`, {});
                    this.$notify({
                        type: "success",
                        message: `Registro salvo com sucesso`,
                    });
                    this.load();
                }
                else
                    this.selecionado = this.selecionado == 1 ? 0 : 1;

            }
            else {
                await this.$service.put(`liberar/${this.selecionado}/${this.departamento.id}/${0}`, {});
                this.$notify({
                    type: "success",
                    message: `Registro salvo com sucesso`,
                });
                this.load();

            }


        },
        async selecionarIndividual(item) {

            if (item.selecionado == 0) {
                let response = await this.$confirm(
                    "Após a operação, todos os acessos dos usuários desse módulo serão desativados. Tem certeza que deseja continuar?"
                );

                if (response == true) {
                    await this.$service.put(`liberar/${item.selecionado}/${this.departamento.id}/${item.idModulo}`, {});
                    this.$notify({
                        type: "success",
                        message: `Registro salvo com sucesso`,
                    });
                    this.load();
                }
                else
                    item.selecionado = item.selecionado == 1 ? 0 : 1;

            }
            else {
                await this.$service.put(`liberar/${item.selecionado}/${this.departamento.id}/${item.idModulo}`, {});
                this.$notify({
                    type: "success",
                    message: `Registro salvo com sucesso`,
                });
                this.load();

            }


        },
        async load() {
            this.busy = true;
            var { data } = await this.$service.get(`modulos/${this.departamento.id}`);
            this.busy = false;
            this.almoxarifados = data;

        },

        cancelar() {
            this.$emit("close")
        },
    },

}
</script>